import { TAvailableConfigValues } from '@customTypes/common';

export interface IFragmentLoaderConfig {
  fragmentLoadingTimeout?: number;
  workerMode?: boolean;
}

export const defaultFragmentLoaderConfig: IFragmentLoaderConfig = {
  fragmentLoadingTimeout: 2500,
  workerMode: true,
};

export const availableFragmentLoaderConfigValues: TAvailableConfigValues<IFragmentLoaderConfig> = {};
